import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const HomeImprovement: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <g clipPath="url(#clip0_507_422)">
                <IconPath
                    d="M20.25 10.75V21.25C20.25 21.6478 20.092 22.0293 19.8107 22.3107C19.5294 22.592 19.1478 22.75 18.75 22.75H5.25C4.85218 22.75 4.47064 22.592 4.18934 22.3107C3.90804 22.0293 3.75 21.6478 3.75 21.25V10.75M0.75 9.24999L11.113 1.64999C11.3703 1.46135 11.681 1.35963 12 1.35963C12.319 1.35963 12.6297 1.46135 12.887 1.64999L23.25 9.24999M18.75 1.74999H21.75V4.74999M13.5 19.75V17.224C14.1137 17.0139 14.6738 16.6717 15.141 16.2217C15.6082 15.7718 15.9711 15.2248 16.2041 14.6194C16.4371 14.0141 16.5346 13.365 16.4896 12.7179C16.4447 12.0707 16.2584 11.4414 15.944 10.874C15.944 10.874 13.896 12.966 13.679 13.244C13.5596 13.3977 13.4089 13.5243 13.2369 13.6153C13.0649 13.7064 12.8755 13.7598 12.6813 13.7721C12.4871 13.7844 12.2925 13.7553 12.1103 13.6866C11.9282 13.618 11.7628 13.5114 11.625 13.374C11.4877 13.2362 11.3813 13.0708 11.3128 12.8888C11.2442 12.7068 11.2151 12.5123 11.2274 12.3182C11.2397 12.1241 11.2931 11.9348 11.3841 11.7629C11.475 11.591 11.6015 11.4404 11.755 11.321C12.033 11.103 14.125 9.05599 14.125 9.05599C13.551 8.73421 12.9115 8.54653 12.2546 8.50705C11.5978 8.46756 10.9404 8.57729 10.332 8.82799C9.48016 9.16259 8.75126 9.7501 8.24341 10.5115C7.73555 11.2728 7.47311 12.1715 7.49141 13.0865C7.50971 14.0015 7.80787 14.8889 8.34577 15.6294C8.88366 16.3698 9.63546 16.9277 10.5 17.228V19.75"
                    {...pathProps}
                />
            </g>
            <defs>
                <clipPath id="clip0_507_422">
                    <rect width="24" height="24" fill="transparent" />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
